export default function Rust_Strings() {
  return (
    <div>
      <h1>Rust_Strings Component</h1>
      <p>This is the Rust_Strings page.</p>
    </div>
  );
}
